<script>
    import RecipesPage from "./RecipesPage.svelte";
    export let firstSet;
    export let cuisines;
    export let cookingMethods;
    export let occasions;
    export let dietary;
    export let flavors;
    export let bakingTypes;
    export let thisCategory;

</script>
<RecipesPage thisCategory={thisCategory}
             firstSet={firstSet}
             cuisines={cuisines}
             cookingMethods={cookingMethods}
             occasions={occasions}
             dietary={dietary}
             flavors={flavors}
             bakingType={bakingTypes}/>
